<template>
    <div class="col-12">
        <p class="guarantees-title fw-bold mb-0">
            {{ title }}
        </p>
        <div class="accordion">
            <div v-for="(guarantee, index) in guarantees" :key="'guarantee-' + index">
                <div class="card multi">
                    <div :id="'heading-guarantee-' + index" class="card-header">
                        <button
                            class="collapsed"
                            data-bs-toggle="collapse"
                            :data-bs-target="'#guarantee-collapse-'+ index"
                            :aria-controls="'#' + 'guarantee-collapse-'+ index"
                            aria-expanded="false"
                        >
                            <span class="accordion-card-title">
                                <span class="accordion-title" v-html="guarantee.title" />
                                <span class="accordion-icon" aria-hidden="true" />
                            </span>
                        </button>
                    </div>
                    <div
                        :id="'guarantee-collapse-'+ index"
                        class="collapse"
                        :aria-labelledby="'guarantee-'+ index"
                    >
                        <div class="accordion-card-body standard">
                            <p v-if="guarantee.description" v-html="guarantee.description" />
                            <ul class="list mb-0">
                                <li
                                    v-for="(advantage, pointer) in guarantee.advantages"
                                    :key="'guarantee-advantage-' + pointer"
                                >
                                    <span v-html="advantage" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Guarantees",
    props: {
        dto: {
            type: Object,
            required: true
        }
    },
    computed: {
        title() {
            return this.dto.title;
        },
        guarantees() {
            return this.dto.guarantees;
        }
    },
    methods: {}
}
</script>
<style scoped lang="scss">
@import 'ob1_variables';

.guarantees-title {
    font-size: 18px;
}

@media (max-width: #{map-get($grid-breakpoints, lg)}) {
    .guarantees-title {
        font-size: 16px;
    }
}
</style>
